import { api } from '@services';

interface IDeleteInUseEquipmentStatus {
  id: string;
  newEquipmentStatusId: string;
}

const deleteInUseEquipmentStatus = async ({
  id,
  newEquipmentStatusId,
}: IDeleteInUseEquipmentStatus): Promise<void> => {
  await api.delete<void>(
    `/equipmentStatus/${id}/inUse?statusId=${newEquipmentStatusId}`,
  );
};

export { deleteInUseEquipmentStatus };
